// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setPatientExternalDocuments,
  resetPatientExternalDocuments
} from 'src/store/modules/patient/externalDocuments'

const initialState = {
  externalDocuments: []
}

export default handleActions(
  {
    [setPatientExternalDocuments](state, { payload: externalDocuments }) {
      return {
        ...state,
        externalDocuments
      }
    },

    [resetPatientExternalDocuments]() {
      return initialState
    }
  },
  initialState
)
